<template>
  <div>
    <v-app-bar
      color="#FFF9F2"
      depressed
      flat
      height="90"
      class="z-index-2"
      :class="{ 'px-15': $vuetify.breakpoint.mdAndUp }"
    >
      <v-app-bar-nav-icon
        v-if="$vuetify.breakpoint.mdAndDown"
        @click="toggleDrawer"
      >
        <hm-icon height="25" width="25">
          <menu-icon />
        </hm-icon>
      </v-app-bar-nav-icon>

      <v-row align="center" v-if="false">
        <v-col cols="4" md="6" v-if="$vuetify.breakpoint.mdAndUp">
          <v-text-field
            rounded
            hide-details
            class="pa-0 ma-0"
            label="Search"
            dense
            prepend-inner-icon="mdi-magnify"
            outlined
          ></v-text-field>
        </v-col>
      </v-row>

      <v-spacer></v-spacer>
      <div class="d-flex align-center">
        <!-- <v-menu offset-y left transition="slide-y-transition" bottom min-width="400">
          <template v-slot:activator="{ on, attrs }">
            <v-btn text icon color="transparent" :ripple="false" v-bind="attrs" v-on="on">
              <hm-icon height="42" width="40" class="cursor-pointer">
                <bell-icon />
              </hm-icon>
            </v-btn>
          </template>
          <v-list>
            <v-list-item class="px-8 py-2" v-for="i in 5" :key="i">
              <v-list-item-icon>
                <v-icon size="12" color="primary">mdi-circle</v-icon>
              </v-list-item-icon>
              <v-list-item-title>New homes are available. Hurry now!</v-list-item-title>
            </v-list-item>
          </v-list>
        </v-menu> -->
        <!-- <hm-icon height="42" width="40" class="cursor-pointer">
          <bell-icon />
        </hm-icon>-->

        <v-menu transition="slide-y-transition" bottom offset-y>
          <template v-slot:activator="{ on, attrs }">
            <!-- <v-btn class="purple" color="primary" dark v-bind="attrs" v-on="on">Slide Y Transition</v-btn> -->
            <v-avatar
              v-bind="attrs"
              v-on="on"
              size="60"
              color="grey lighten-3"
              class="ml-5 cursor-pointer"
            >
              <v-avatar size="50">
                <v-img :src="userObj.photourl">
                  <template v-slot:placeholder>
                    <v-avatar color="secondary" size="100%">
                      <span
                        v-if="userObj.firstname && userObj.lastname"
                        class="white--text text-body-1 font-weight-bold"
                      >
                        {{ userObj.firstname[0] }}
                        {{ userObj.lastname[0] }}
                      </span>
                    </v-avatar>
                  </template>
                </v-img>
              </v-avatar>
            </v-avatar>
          </template>
          <v-list>
            <v-list-item
              @click="item.action"
              class="px-5"
              v-for="(item, i) in menuItems"
              :key="i"
            >
              <v-list-item-title>{{ item.title }}</v-list-item-title>
            </v-list-item>
          </v-list>
        </v-menu>
      </div>
    </v-app-bar>
    <v-navigation-drawer
      v-model="drawer"
      overlay-color="primary"
      app
      :permanent="$vuetify.breakpoint.mdAndUp"
      class="primary pa-5 z-index-3"
    >
      <v-list-item>
        <v-list-item-content>
          <v-list-item-title class="title">
            <homify-icon />
          </v-list-item-title>
        </v-list-item-content>
      </v-list-item>

      <v-list dense nav v-for="item in items" :key="item.title">
        <v-subheader class="grey--text lighten-4 font-weight-medium">{{
          item.title
        }}</v-subheader>
        <v-list-item
          dark
          :ripple="false"
          active-class="secondary--text"
          v-for="listItem in item.items"
          :key="listItem.title"
          exact
          link
          color="primary"
          class="py-1"
          :to="{ name: listItem.route }"
        >
          <v-list-item-icon class="pa-0 mr-3">
            <hm-icon height="29" width="29">
              <component :is="listItem.icon" />
            </hm-icon>
          </v-list-item-icon>

          <v-list-item-content class="pa-0 mx-0">
            <v-list-item-title class="text-body-1 font-weight-medium">
              {{ listItem.title }}
            </v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </v-list>
    </v-navigation-drawer>
  </div>
</template>

<script>
import MenuIcon from "@/components/icons/MenuIcon.vue";
import HmIcon from "@/components/HmIcon.vue";
import BellIcon from "@/components/icons/dashboard/BellIcon.vue";
import HomesIcon from "./../icons/sidebar/SbHomesIcon.vue";
import LandbankIcon from "./../icons/sidebar/SbLandbankIcon.vue";
import InvestmentIcon from "./../icons/sidebar/SbInvestmentIcon.vue";
import DashboardIcon from "./../icons/sidebar/SbDashboardIcon.vue";
import ReferalIcon from "./../icons/sidebar/SbReferalIcon.vue";
import WalletIcon from "./../icons/sidebar/SbWalletIcon.vue";
import SettingsIcon from "./../icons/sidebar/SbSettingsIcon.vue";
import ProfileIcon from "./../icons/sidebar/SbProfileIcon.vue";
import HomifyIcon from "@/assets/svg/homify-logo__mini.svg";
import { mapState, mapActions } from "vuex";

export default {
  components: {
    HmIcon,
    BellIcon,
    MenuIcon,
    HomifyIcon,
    HomesIcon,
    LandbankIcon,
    InvestmentIcon,
    DashboardIcon,
    ReferalIcon,
    WalletIcon,
    SettingsIcon,
    ProfileIcon,
  },
  data() {
    return {
      drawer: null,
      items: [
        {
          title: "MENU",
          items: [
            {
              title: "Dashboard",
              icon: "dashboard-icon",
              route: "dashboard.index",
            },
            {
              title: "Lands",
              icon: "landbank-icon",
              route: "dashboard.lands",
            },

            { title: "Homes", icon: "homes-icon", route: "dashboard.homes" },

            {
              title: "Investments",
              icon: "investment-icon",
              route: "dashboard.investments",
            },
            {
              title: "Landbank",
              icon: "landbank-icon",
              route: "dashboard.landbank",
            },
            { title: "Wallet", icon: "wallet-icon", route: "dashboard.wallet" },
            {
              title: "Referrals",
              icon: "referal-icon",
              route: "dashboard.referals",
            },
          ],
        },
        {
          title: "ACCOUNT",
          items: [
            // {
            //   title: "Settings",
            //   icon: "settings-icon",
            //   route: "dashboard.settings",
            // },
            {
              title: "Profile",
              icon: "profile-icon",
              route: "dashboard.profile",
            },
          ],
        },
      ],
      menuItems: [
        {
          title: "Log Out",
          action: () => {
            return this.logout();
          },
        },
      ],
    };
  },
  computed: {
    ...mapState(["userObj"]),
    // drawer() {
    //   return this.$store.state.drawer;
    // },
  },
  methods: {
    ...mapActions("auth", ["logout"]),
    toggleDrawer() {
      this.drawer = !this.drawer;
      //     console.log('toggling')
      //   this.$store.commit("toggleDrawer");
    },
    goToPage(name) {
      this.$router.push({ name });
    },
    handleLogout() {
      this.logout();
      // this.goToPage("auth.login");
    },
  },
};
</script>

<style lang="scss" scoped>
.z-index-2 {
  z-index: 10;
}

.z-index-3 {
  z-index: 11;
}
</style>
